/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ITileListItemViewProps } from './tile-list-item';

/**
 *
 * ITileListItemViewProps component.
 * @param props - Component props.
 * @returns TileListView.
 */
const renderTileListItemContent = (props: ITileListItemViewProps): JSX.Element => {
    const { heading, paragraph, backgroundImage, links, thumbnailImage,
        tileListContainer, tileListImageContainer, tileListThumbnailImageContainer, tileListHeadingContainer } = props;

    return (
        <Node {...tileListContainer}>
            <Node {...tileListImageContainer}>
                {backgroundImage}
            </Node>
            <Node {...tileListHeadingContainer}>
                {heading}
                {paragraph}
                {links}
            </Node>
            <Node {...tileListThumbnailImageContainer}>
                {thumbnailImage}
            </Node>
        </Node>
    );
};

/**
 *
 * TileListItemViewProps component.
 * @param props - Component props.
 * @returns TileListView.
 */
export const TileListItemViewComponent: React.FC<ITileListItemViewProps> = props => {
    const { tileListItem } = props;
    return (
        <Module {...tileListItem}>
            {renderTileListItemContent(props)}
        </Module>
    );
};

export default TileListItemViewComponent;
